import { ReactNode } from 'react';

import { Stack, Typography } from '@mui/material';

export const HomeLayout = ({
  title,
  children,
}: {
  title: string;
  children?: ReactNode;
}) => {
  return (
    <Stack spacing={1}>
      <Typography fontWeight={400} lineHeight={1.33} fontSize={18}>
        {title}
      </Typography>
      {children}
    </Stack>
  );
};
